import AdminPurchasedCustomPrintConfiguratorPreviewPane from './AdminPurchasedCustomPrintConfiguratorPreviewPane';

export default AdminPurchasedCustomPrintConfiguratorPreviewPane;
